/**
 * Route wrapper that gates access by a resolved permission from AuthProvider,
 * mirroring ProtectedRouteWithSupabase's loading/redirect/Outlet pattern.
 */
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';
import { Loader2 } from 'lucide-react';

export interface RequirePermissionProps {
  perm: string;
  minimum?: 'view' | 'edit';
  redirectTo?: string;
  children?: React.ReactNode;
}

export function RequirePermission({
  perm,
  minimum = 'view',
  redirectTo = '/search-vehicle',
  children,
}: RequirePermissionProps) {
  const { loading, permissionsLoading, can } = useAuth();

  if (loading || permissionsLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!can(perm, minimum)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
}
